export { default as videoCallSchedulingSuccessModel } from './model'
